import Api, { getAccessToken } from "api";

export interface ResGetTimeTracking {
	userId: string;
	userName: string;
	userEmail: string;
	missions: Record<
		string,
		{
			totalActiveSeconds: number;
			startTime?: string;
			endTime?: string;
			lastPulse?: string;
			isActive?: boolean;
		}
	>;
}

export class TimeTracking
{
	async getDataTimeTracking()
	{
		return (
			await Api.instance.get<ResGetTimeTracking[]>(
				"/admin/getMissionsTimes",
				{
					headers:
					{
						"Content-Type": "application/x-www-form-urlencoded",
						Authorization: "Bearer " + getAccessToken()
					}
				}
			)
		).data;
	}
}
